<template lang="pug">
v-card(
  :disabled="disabled"
  @click="routeTo"
).sdo-card.mb-2.card-hover
  v-list-item.mb-0.py-1
    v-list-item-action.mr-3
      tooltip-wrap(:text="TASK_STATUS_NAMES[task.status]")
        v-icon.mr-2(:color="TASK_STATUS_COLORS[task.status]") {{ TASK_STATUS_ICONS[task.status] }}

    v-list-item-content
      .text-body-2.warning--text(
        v-if="task.status === $conf.TASK_STATUSES.inProcess"
      ): strong Задание ещё не отправлено вами на проверку

      span: span.card-title {{ task.title }}

      .caption.error--text(
        v-if="checkDisabled(task) && !showBtn"
      ) Пока снова пройти тест нельзя
      .text-caption {{ task.user_attempts }}/{{ task.attempt }} попыток

      v-btn(
        v-if="showResults"
        small
        depressed
        color="grey lighten-3"
        @click.stop="toggleContent"
      ).mt-2
        span {{ content ? "Закрыть" : 'Результаты' }}
        v-icon {{ content ? 'mdi-chevron-up' : 'mdi-chevron-down' }}

    v-list-item-action.text-right.pb-0(
      v-if="isPassButtonVisible(task.status)"
    )
      v-icon(color="primary") mdi-arrow-right

  v-expand-transition
    journal-list(
      v-if="content"
      :task="task"
      :user-id="userId"
      :is-consult="isConsult"
    )
</template>

<script>
import {
  TASK_STATUSES,
  TASK_STATUS_NAMES,
  TASK_STATUS_COLORS,
  TASK_STATUS_ICONS,
} from '@/utils/constants';

import JournalList from '../JournalsList.vue';

export default {
  name: 'LessonList',
  components: {
    JournalList,
  },
  props: {
    task: { type: Object, required: true },
    course: { type: Object, required: true },
    idx: { type: Number, default: null },
    isConsult: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      TASK_STATUS_ICONS,
      TASK_STATUS_COLORS,
      TASK_STATUS_NAMES,

      content: false,
    };
  },
  computed: {
    showResults() {
      const { notPassed, notChecked, inProcess } = TASK_STATUSES;
      return this.task.user_attempts > 1
        || ![notPassed, notChecked, inProcess].includes(this.task.status);
    },
    markColor() {
      return {
        1: 'error',
        2: 'error',
        3: 'warning',
        4: 'success',
        5: 'success',
      };
    },
    showBtn() {
      return ![
        TASK_STATUSES.inProcess,
        TASK_STATUSES.notPassed,
        TASK_STATUSES.notChecked,
      ].includes(this.task.status);
    },
    userId() {
      return this.$route.query.user || this.$user.data.id;
    },
  },
  methods: {
    routeTo() {
      if (
        !this.checkDisabled()
        && ![
          TASK_STATUSES.success,
          TASK_STATUSES.done,
          TASK_STATUSES.notChecked,
        ].includes(this.task.status)
      ) {
        this.$router.push({
          name: 'TaskPass',
          params: { id: this.task.id },
          query: { groupId: this.course.user_group_id },
        });
      }
    },
    toggleContent() {
      this.content = !this.content;
    },
    checkDisabled() {
      const { task } = this;
      return !((task.user_attempts)
        !== task.attempt || task.status === TASK_STATUSES.inProcess);
    },
    isPassButtonVisible(taskStatus) {
      return ([
        TASK_STATUSES.inProcess,
        TASK_STATUSES.retake,
        TASK_STATUSES.notPassed,
        TASK_STATUSES.fail,
      ].includes(taskStatus) && !this.isConsult);
    },
  },
};
</script>
